import React from 'react';
import FooterDrawer from '@/components/ui/atoms/FooterDrawer';
import MTextArea from '@/components/ui/atoms/MTextArea';

interface DocumentCommentDrawerProps {
  open: boolean;
  onClose: () => void;
  initialValue: string;
  onDone: (value: string) => Promise<void>;
  loading?: boolean;
  title?: string;
}

const DocumentCommentDrawer: React.FC<DocumentCommentDrawerProps> = ({
  open,
  onClose,
  initialValue,
  onDone,
  loading = false,
  title = 'Add Comment',
}) => {
  const [value, setValue] = React.useState(initialValue);
  const [submitting, setSubmitting] = React.useState(false);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue, open]);

  const handleDone = async () => {
    setSubmitting(true);
    try {
      await onDone(value);
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <FooterDrawer
      open={open}
      onClose={onClose}
      onDone={handleDone}
      doneDisabled={loading || submitting || value === initialValue}
      title={title}
    >
      <div style={{ padding: 16 }}>
        <MTextArea
          value={value}
          onChange={e => setValue(e.target.value)}
          placeholder="Add a comment about this document..."
          rows={4}
          autoFocus
          className='w-full max-w-full'
          maxLength={250}
        />
      </div>
    </FooterDrawer>
  );
};

export default DocumentCommentDrawer;
